import React from "react";

// useStyles
import useStyles from "./styles/ListRekening";

import { Divider, Typography } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import { useState } from "react";
import DialogRekening from "./dialog";
// import { useData } from "../../components";

function ListRekening({ data, length }) {
  const classes = useStyles();

  const [dialog, setDialog] = useState({
    open: false,
    data: {},
    mode: "Tambah",
  });

  return (
    <>
      <div
        className={classes.head}
        onClick={() => setDialog({ open: true, data: data, mode: "Edit" })}
      >
        <div>
          <Typography className={classes.title}>{data.nama_bank}</Typography>
          <Typography className={classes.bodyTitle}>
            {data.no_rek} a.n {data.nama_rek}
          </Typography>
          {!data.code_bank ? (
            <Typography className={classes.alert} color="error">
              Mohon perbaharui data rekening
            </Typography>
          ) : null}
        </div>
        <div>
          <EditIcon className={classes.icon} />
        </div>{" "}
      </div>
      <Divider style={{ margin: "15px -15px" }} />
      <DialogRekening
        open={dialog.open}
        data={dialog.data}
        mode={dialog.mode}
        handleClose={() => setDialog({ open: false, data: {}, mode: "Tambah" })}
      />
    </>
  );
}

export default ListRekening;
